(function () {
  'use strict';

  // ─── Config ──────────────────────────────────────────────────────────────────
  // Leemos la configuración que Liquid inyectó en el DOM.
  // Nunca hardcodeamos credenciales en JS.
  /* Señal interna: solo loguea si activas el flag (localStorage.dbg='1').
     Silencioso por defecto — no expone arquitectura a terceros. */
  function logEngine(primary, err) {
    try { if (localStorage.getItem('dbg') !== '1') return; } catch (e) { return; }
    if (primary) { console.log('🟢 TS ok'); return; }
    console.warn('🟡 TS down', err ? (err.name + ': ' + err.message) : '(circuit breaker)');
  }

  /* Circuit breaker con TTL: un fallo NO mata Typesense toda la sesión.
     Guarda timestamp; expira a los 60s → reintenta TS solo (auto-recuperación).
     Valor legacy '1' (sin timestamp) se trata como expirado. */
  var TS_DOWN_TTL = 60000;
  function tsRecentlyDown() {
    try {
      var t = parseInt(sessionStorage.getItem('ts:down'), 10);
      if (!t || t < 1000000000000) { sessionStorage.removeItem('ts:down'); return false; }
      if (Date.now() - t < TS_DOWN_TTL) return true;
      sessionStorage.removeItem('ts:down');
    } catch (e) {}
    return false;
  }
  function markTsDown() {
    try { sessionStorage.setItem('ts:down', String(Date.now())); } catch (e) {}
    tsDown = true;
  }

  var configEl = document.getElementById('ts-search-config');
  if (!configEl) {
    logEngine(false);
    return; // Typesense no está habilitado, el fallback nativo ya está en el HTML
  }

  function showNativeFallback() {
    var main = document.getElementById('search-main');
    var nativeFallback = document.getElementById('search-native-fallback');
    if (nativeFallback && nativeFallback.children.length > 0) {
      if (main) main.style.display = 'none';   // oculta resultados TS (no el toolbar)
      nativeFallback.style.display = '';        // muestra resultados nativos
      // TS caído no re-ordena server-side → ocultar el botón Ordenar
      var sortWrap = document.getElementById('search-sort-wrap');
      if (sortWrap) sortWrap.style.display = 'none';
      // Mueve las facetas nativas al drawer compartido para que el botón Filtro las abra
      var nf = nativeFallback.querySelector('.search-sidebar__body');
      var drawerBody = document.getElementById('search-facets');
      if (nf && drawerBody && !drawerBody.dataset.nativeLoaded) {
        drawerBody.innerHTML = nf.innerHTML;
        drawerBody.dataset.nativeLoaded = '1';
        // Solo en móvil: el #search-sidebar es el drawer que abre el botón Filtro.
        // En desktop es una columna estática → des-ocultarlo lo mostraba
        // full-width arriba (duplicado del sidebar propio del fallback).
        var sb = document.getElementById('search-sidebar');
        if (sb && window.matchMedia('(max-width: 767px)').matches) sb.hidden = false;
      }
      return true;
    }
    return false;
  }

  /* Circuit breaker compartido con el predictive search: si Typesense ya falló
     en esta sesión, mostrar el fallback nativo sin esperar. NO retornamos:
     seguimos cableando el toolbar (Filtro/Ordenar) para que funcionen igual. */
  var tsDown = false;
  if (tsRecentlyDown() && showNativeFallback()) {
    logEngine(false);
    tsDown = true;
  }

  var config = JSON.parse(configEl.textContent);
  var perPage = config.perPage || 60;
  var showVendor = config.showVendor !== false;
  var currentSearchId = 0; // evita que búsquedas anteriores sobreescriban resultados más nuevos
  var lastResultCount = null;

  // ─── Elementos del DOM ───────────────────────────────────────────────────────
  var searchLayout     = document.getElementById('search-layout');
  var countEl          = document.getElementById('search-count');
  var facetsEl         = document.getElementById('search-facets');
  var activeFiltersEl  = document.getElementById('search-active-filters');
  var resultsEl        = document.getElementById('search-results');
  var loadingEl        = document.getElementById('search-loading');
  var emptyEl          = document.getElementById('search-empty');
  var emptyMsgEl       = document.getElementById('search-empty-msg');
  var emptyContextEl   = document.getElementById('search-empty-context');
  var errorEl          = document.getElementById('search-error');
  var paginationEl     = document.getElementById('search-pagination');
  var sidebarEl        = document.getElementById('search-sidebar');
  var backdropEl       = document.getElementById('filters-backdrop');
  var analyticsRoot    = document.querySelector('[data-analytics-section="search-results"]');

  function show(el) { el.hidden = false; el.style.display = ''; }
  function hide(el) { el.style.display = 'none'; el.hidden = true; }

  function intentUtils() {
    return window.ThemeUtils && ThemeUtils.searchIntent;
  }

  function fetchSearch(url, options) {
    var utils = intentUtils();
    return utils ? utils.fetchSearch(url, options) : fetch(url, options);
  }

  function searchRules(query, approximate) {
    var intent = intentUtils();
    if (intent) return intent.typesenseParams(query, approximate);
    return {
      query_by: 'title,sku,vendor,product_type',
      query_by_weights: '4,3,1,1',
      num_typos: approximate ? '1' : '0',
      typo_tokens_threshold: approximate ? '1' : '0',
      drop_tokens_threshold: '0'
    };
  }

  function addSearchRules(qs, query, approximate) {
    var rules = searchRules(query, approximate);
    Object.keys(rules).forEach(function(key) { qs.set(key, rules[key]); });
  }

  // ─── Estado ──────────────────────────────────────────────────────────────────
  // Todo el estado de la búsqueda vive en la URL.
  // Leemos URL → buscamos → pintamos. Nunca guardamos estado local.

  function getParams() {
    var p = new URLSearchParams(window.location.search);
    return {
      q:            p.get('q') || '',
      page:         parseInt(p.get('page') || '1', 10),
      sort:         p.get('sort') || 'relevance',
      vendor:       p.getAll('vendor'),
      product_type: p.getAll('product_type'),
      available:    p.get('available') || '',
      aprox:        p.get('aprox') || '',
      sinStock:     p.get('sin_stock') === 'true',
      price_min:    p.get('price_min') || '',
      price_max:    p.get('price_max') || '',
    };
  }

  function captureSearch(eventName, params, extra) {
    if (!window.TMSAnalytics) return;
    TMSAnalytics.capture(eventName, Object.assign({
      search_surface: 'results_page',
      search_engine: tsDown ? 'shopify_native' : 'typesense',
      query: params.q,
      page: params.page,
      sort: params.sort,
      vendors: params.vendor,
      product_types: params.product_type,
      availability: params.available,
      price_min: params.price_min,
      price_max: params.price_max,
      result_count: lastResultCount
    }, extra || {}));
  }

  // ─── Typesense API ───────────────────────────────────────────────────────────
  // Usamos fetch() directo a la REST API de Typesense.
  // Esto evita tener que cargar el SDK de Typesense (~40KB) en el cliente.

  function buildFilterBy(params) {
    var parts = [];

    if (params.vendor.length) {
      var vendors = expandFilterValues('vendor', params.vendor);
      parts.push('vendor:=[' + vendors.map(function(v) { return '`' + v + '`'; }).join(',') + ']');
    }
    if (params.product_type.length) {
      var types = expandFilterValues('product_type', params.product_type);
      parts.push('product_type:=[' + types.map(function(v) { return '`' + v + '`'; }).join(',') + ']');
    }
    if (params.available === 'true') {
      parts.push('available:=true');
    } else if (params.available === 'false') {
      parts.push('available:=false');
    }
    if (params.price_min !== '') {
      parts.push('price:>=' + parseInt(params.price_min, 10));
    }
    if (params.price_max !== '') {
      parts.push('price:<=' + parseInt(params.price_max, 10));
    }

    return parts.join('&&');
  }

  /* Mensaje de "sin resultados". Si el filtro de existencia es lo único que
     los esconde, se dice cuántos hay agotados y se ofrece un enlace. */
  function mostrarVacio(params) {
    emptyMsgEl.textContent = 'No encontramos nada para "' + params.q + '".';
    emptyEl.querySelectorAll('.search-empty__show-all').forEach(function(el) { el.remove(); });
    if (emptyContextEl) emptyContextEl.innerHTML = '';
    show(emptyEl);

    function consultar(extra) {
      var qs = new URLSearchParams({
        q: params.q || '*',
        per_page: 0,
      });
      addSearchRules(qs, params.q, Boolean(extra && extra.approximate));
      Object.keys(extra || {}).forEach(function(key) {
        if (key !== 'approximate') qs.set(key, extra[key]);
      });
      return fetchSearch(config.host + '/collections/' + config.collection + '/documents/search?' + qs, {
        headers: { 'X-TYPESENSE-API-KEY': config.apiKey }
      }).then(function(r) { return r.ok ? r.json() : null; });
    }

    function boton(texto, alPulsar) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'search-empty__show-all';
      b.textContent = texto;
      b.addEventListener('click', alPulsar);
      emptyMsgEl.insertAdjacentElement('afterend', b);
    }

    function mostrarAlternativasContextuales() {
      var utils = intentUtils();
      if (!emptyContextEl || !utils) return Promise.resolve();
      var intent = utils.resolveIntent(params.q);
      if (!intent) return Promise.resolve();

      var intentFilter = utils.filterForIntent(intent);
      var vendors = intent.alternativeVendors || [];

      function consultarAlternativas(vendor) {
        var qs = new URLSearchParams({
          q: intent.query,
          per_page: 8,
          page: 1,
          sort_by: '_text_match:desc,created_at:desc'
        });
        addSearchRules(qs, intent.query, false);
        qs.set('filter_by', ['available:=true', intentFilter,
          vendor ? 'vendor:=[`' + vendor.replace(/`/g, '\\`') + '`]' : ''
        ].filter(Boolean).join('&&'));
        if (intent.preset) {
          qs.set('preset', intent.preset);
          qs.delete('sort_by');
        }
        return fetchSearch(config.host + '/collections/' + config.collection + '/documents/search?' + qs, {
          headers: { 'X-TYPESENSE-API-KEY': config.apiKey }
        }).then(function(r) { return r.ok ? r.json() : null; })
          .then(function(data) { return data && data.hits ? data.hits : []; })
          .catch(function() { return []; });
      }

      return Promise.all((vendors.length ? vendors : [null]).map(consultarAlternativas))
        .then(function(groups) {
          // Alternamos marcas para que ambas sean visibles desde la primera fila.
          // Si una tiene menos referencias, la otra completa los ocho espacios.
          var hits = [];
          for (var i = 0; hits.length < 8 && groups.some(function(group) { return group[i]; }); i += 1) {
            groups.forEach(function(group) {
              if (group[i] && hits.length < 8) hits.push(group[i]);
            });
          }
          if (!hits.length) return;
          var category = (config.contextualLabels && config.contextualLabels[intent.key]) || intent.key;
          var label = String(config.contextualAlternatives || '__CATEGORY__').replace('__CATEGORY__', category);
          emptyContextEl.innerHTML = '<div class="search-contextual">'
            + '<p class="search-contextual__label">' + escapeHtml(label) + '</p>'
            + '<div class="search-contextual__grid cards-list">'
            + hits.map(function(hit) { return renderCard(hit.document); }).join('')
            + '</div></div>';
          document.dispatchEvent(new CustomEvent('wishlist:change'));
          captureSearch('tms_search_contextual_fallback', params, {
            fallback_intent: intent.key,
            fallback_result_count: hits.length
          });
        }).catch(function() {});
    }

    /* ¿El término existe en el catálogo, solo que agotado? Se comprueba sin el
       filtro y sin erratas: si hay coincidencias exactas, el cliente escribió
       bien y lo que falta es stock. Si no hay ninguna, entonces sí tiene
       sentido ofrecer resultados aproximados. */
    consultar()
      .then(function(d) {
        if (d && d.found > 0) {
          if (params.available !== 'true') return;
          boton(d.found === 1 ? 'Ver 1 producto agotado'
                              : 'Ver ' + d.found.toLocaleString('es-CO') + ' productos agotados',
                function() { navigate(Object.assign({}, params, { available: '', sinStock: true, page: 1 }), true); });
          /* Un resultado exacto agotado no debe dejar al cliente sin opciones:
             para las familias locales conocidas conservamos el acceso al
             agotado y mostramos alternativas disponibles de la misma familia. */
          return mostrarAlternativasContextuales();
        }
        var utils = intentUtils();
        if (utils && utils.isIdentifier(params.q)) return mostrarAlternativasContextuales();
        return consultar({ approximate: true }).then(function(a) {
          if (!a || !a.found) return mostrarAlternativasContextuales();
          boton('Ver ' + a.found.toLocaleString('es-CO') + ' resultados aproximados',
                function() { navigate(Object.assign({}, params, { aprox: 'true', page: 1 }), true); });
        });
      })
      .catch(function() {});
  }

  function doSearch(params) {
    var sortByMap = {
      price_asc:  'available:desc,price:asc',
      price_desc: 'available:desc,price:desc',
      newest:     'available:desc,created_at:desc',
    };
    /* Orden explícito elegido por el cliente (precio / más nuevos) vs. el orden
       por defecto (relevancia). El orden del cliente siempre gana: la curación
       solo entra en relevancia. */
    var explicitSort = sortByMap[params.sort];
    /* Curación: vive en Typesense como preset `cur-<término>`, no en el tema,
       para que cualquier cliente del índice obtenga el mismo orden. Un preset
       inexistente lo ignora el servidor. */
    var utils = intentUtils();
    var identifierQuery = utils && utils.isIdentifier(params.q);
    var preset = (!explicitSort && !identifierQuery && window.ThemeUtils && ThemeUtils.curationPreset)
      ? ThemeUtils.curationPreset(params.q)
      : null;

    /* El sort_by de la consulta GANA sobre el del preset, así que cuando hay
       preset NO se manda: el orden lo pone él. Si el cliente eligió un orden
       explícito no se pide preset y manda su elección. */
    var sortBy;
    if (explicitSort) {
      sortBy = explicitSort;
    } else if (preset) {
      sortBy = null;
    } else if (params.q && params.q !== '*') {
      sortBy = 'available:desc,_text_match:desc';
    } else {
      sortBy = 'available:desc,created_at:desc';
    }

    var qs = new URLSearchParams({
      q:                params.q || '*',
      /* Sin `description`: buscar dentro del texto largo traía ruido que no
         parecía un resultado. Con q="grasa" salían encordados Elixir, porque su
         descripción dice "protege contra: Sudor, Grasa corporal". El dropdown
         nunca incluyó la descripción, así que además las dos vistas coinciden. */
      /* Typesense devuelve las facetas en este orden y así se pintan:
         precio → tipo → marca → disponibilidad. El tipo va antes que la marca
         porque el cliente primero decide QUÉ instrumento quiere y después de
         qué marca. Mismo orden que en colección. */
      facet_by:         'price,product_type,vendor,available',
      /* Default de Typesense = top 10 valores por faceta: dejaba grafías
         duplicadas (TAMA=21) fuera de la respuesta y el dedupe no podía
         unirlas ni el filtro expandirlas. */
      max_facet_values: 50,
      per_page:         perPage,
      page:             params.page,
    });
    addSearchRules(qs, params.q, params.aprox === 'true');
    if (sortBy) qs.set('sort_by', sortBy);
    if (preset) qs.set('preset', preset);

    var filterBy = buildFilterBy(params);
    if (filterBy) qs.set('filter_by', filterBy);

    var protocol = config.host.startsWith('http') ? '' : 'https://';
    var url = protocol + config.host + '/collections/' + config.collection + '/documents/search?' + qs.toString();

    /* Timeout de 6s: host caído no debe colgar la página de resultados.
       Antes 3s — muy corto en móvil/cold-start, disparaba el breaker de más. */
    var fetchOptions = { headers: { 'X-TYPESENSE-API-KEY': config.apiKey } };
    if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
      fetchOptions.signal = AbortSignal.timeout(6000);
    }

    return fetchSearch(url, fetchOptions).then(function(r) {
      if (!r.ok) throw new Error('Typesense error ' + r.status);
      return r.json();
    });
  }

  // ─── Renderizado ─────────────────────────────────────────────────────────────

  /* Formato de moneda — fuente única en ThemeUtils (src/js/utils.js) */
  function formatMoney(cents) {
    return ThemeUtils.formatMoney(cents, config.moneyFormat);
  }

  /* Espeja el snippet product-card.liquid 1:1 para que el CSS compartido pinte
     idéntico al fallback nativo (el usuario no debe notar si TS está activo). */
  function renderCard(doc) {
    var price = formatMoney(doc.price);
    var hasDiscount = doc.compare_at_price && doc.compare_at_price > doc.price;
    var unavailable = !doc.available;
    var title = escapeHtml(doc.title);
    var handle = doc.handle || (doc.url || '').split('?')[0].split('/').pop();

    // Media (badge agotado + imagen o placeholder con ícono)
    var media = '<a href="' + doc.url + '" class="product-card__media" aria-label="' + title + '">'
      + (unavailable ? '<span class="product-card__badge product-card__badge--sold-out">' + escapeHtml(config.soldOutLabel || 'Agotado') + '</span>' : '')
      + (doc.image
          ? '<img src="' + escapeHtml(doc.image) + '" alt="' + title + '" loading="lazy" decoding="async" class="product-card__image">'
          : '<div class="product-card__image-placeholder"><svg class="icon icon-xl icon-stroke"><use href="#icon-package"></use></svg></div>')
      + '</a>';

    // Botón wishlist (mismos data-attrs que snippets/wishlist-button.liquid)
    var wishAdd = escapeHtml(config.wishlistAdd || '');
    var wishlist = '<button type="button" class="wishlist-btn" data-wishlist-toggle'
      + ' data-handle="' + escapeHtml(handle) + '"'
      + ' data-title="' + title + '"'
      + ' data-url="' + escapeHtml(doc.url) + '"'
      + ' data-image="' + escapeHtml(doc.image || '') + '"'
      + ' data-price="' + escapeHtml(price) + '"'
      + ' data-available="' + (unavailable ? 'false' : 'true') + '"'
      + ' data-label-add="' + wishAdd + '"'
      + ' data-label-remove="' + escapeHtml(config.wishlistRemove || '') + '"'
      + ' aria-pressed="false" aria-label="' + wishAdd + '">'
      + '<svg class="wishlist-btn__icon icon icon-stroke" aria-hidden="true"><use href="#icon-heart"></use></svg>'
      + '</button>';

    // Discount label — ticket top-right (oculto si agotado: ese espacio lo usa el badge "Agotado")
    var discount = '';
    if (hasDiscount && !unavailable) {
      var pct = Math.round((doc.compare_at_price - doc.price) * 100 / doc.compare_at_price);
      discount = '<span class="discount-label"><svg class="icon icon-fill" aria-hidden="true"><use href="#icon-tag"></use></svg>-' + pct + '%</span>';
    }

    // Botón agregar al carrito. TS no indexa variantes → el handler resuelve
    // por handle (1 variante = add directo; varias = ir al PDP).
    var addBtn = unavailable
      ? '<button type="button" class="product-card__add" disabled>' + escapeHtml(config.soldOutLabel || '') + '</button>'
      : '<button type="button" class="product-card__add" data-quick-add data-handle="' + escapeHtml(handle) + '" data-url="' + escapeHtml(doc.url) + '">' + escapeHtml(config.addLabel || '') + '</button>';

    // Precio (misma estructura que el snippet: __price con --sale + <s --compare>)
    var priceBlock = '<div class="product-card__price">'
      + (hasDiscount
          ? '<s class="product-card__price--compare">' + formatMoney(doc.compare_at_price) + '</s><span class="product-card__price--sale">' + price + '</span>'
          : '<span>' + price + '</span>')
      + '</div>';

    // Barra de acciones: agregar al carrito + ♥ wishlist al lado
    var actions = '<div class="product-card__actions">' + addBtn + wishlist + '</div>';

    var info = '<div class="product-card__info">'
      + discount
      + (showVendor && doc.vendor ? '<span class="product-card__vendor">' + escapeHtml(doc.vendor) + '</span>' : '')
      + '<a href="' + doc.url + '" class="product-card__title">' + title + '</a>'
      + renderStars(doc.rating, doc.reviews_count != null ? doc.reviews_count : doc.rating_count)
      + priceBlock
      + actions
      + '</div>';

    return '<div class="product-card" data-analytics-product'
      + ' data-product-id="' + escapeHtml(doc.id || '') + '"'
      + ' data-product-handle="' + escapeHtml(handle) + '"'
      + ' data-product-title="' + title + '"'
      + ' data-product-vendor="' + escapeHtml(doc.vendor || '') + '"'
      + ' data-product-type="' + escapeHtml(doc.product_type || '') + '">' + media + info + '</div>';
  }

  /* Estrellas — espeja snippets/star-rating.liquid. Requiere que el índice TS
     traiga `rating` (0-5) y `reviews_count`. Sin esos campos no renderiza. */
  function renderStars(rating, count) {
    rating = parseFloat(rating); count = parseInt(count, 10);
    if (!count || count <= 0 || isNaN(rating)) return '';
    var floor = Math.floor(rating);
    var halfAt = (rating - floor) >= 0.5 ? floor + 1 : 0;
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= floor) {
        stars += '<svg class="icon icon-sm icon-fill star-rating__star" aria-hidden="true"><use href="#icon-star"></use></svg>';
      } else if (halfAt > 0 && i === halfAt) {
        stars += '<span class="star-half" aria-hidden="true"><svg class="icon icon-sm icon-stroke star-rating__star star-rating__star--empty"><use href="#icon-star"></use></svg><span class="star-half__fill"><svg class="icon icon-sm icon-fill star-rating__star"><use href="#icon-star"></use></svg></span></span>';
      } else {
        stars += '<svg class="icon icon-sm icon-stroke star-rating__star star-rating__star--empty" aria-hidden="true"><use href="#icon-star"></use></svg>';
      }
    }
    return '<div class="star-rating star-rating--sm" role="img" aria-label="' + rating.toFixed(1) + ' (' + count + ')">' + stars + '<span class="star-rating__count">(' + count + ')</span></div>';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Nombres legibles para las facetas
  /* Etiquetas desde locales vía el config JSON (este bloque no ve Liquid).
     Las de tipo/marca/disponibilidad deben coincidir con las que Shopify
     muestra en colección, o las dos páginas nombran distinto lo mismo. */
  var FACET_LABELS = {
    price:        config.facetPrice        || 'Precio',
    product_type: config.facetType         || 'Tipo de producto',
    vendor:       config.facetVendor       || 'Marca',
    available:    config.facetAvailability || 'Disponibilidad',
  };

  var AVAILABLE_LABELS = {
    'true':  config.inStock    || 'En existencia',
    'false': config.outOfStock || 'Agotado',
  };

  /* Formato de los labels del slider de precio (misma fuente que las cards) */
  function formatPriceLabel(v) {
    return ThemeUtils.formatMoney(v, config.moneyFormat);
  }

  /* La data trae la misma marca/categoría con grafías distintas ("TAMA" vs
     "Tama") → facetas duplicadas. Igual que dedupeFacets() del predictive:
     agrupa case/acento-insensitive, suma counts, muestra la grafía con más
     resultados. Guarda las variantes por display para que el filtro las
     incluya todas (si marcas "Tama" también debe traer "TAMA"). Parche
     front mientras se normaliza el índice (P4-9). */
  var facetVariants = {};

  /* Límites del slider de precio sin filtro activo (por query) */
  var priceBounds = null;

  function dedupeFacetCounts(field, counts) {
    var map = new Map();
    counts.forEach(function(c) {
      var key = c.value
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ').trim();
      var existing = map.get(key);
      if (existing) {
        existing.count += c.count;
        existing.variants.push(c.value);
        if (c.count > existing._winnerCount) { existing.value = c.value; existing._winnerCount = c.count; }
      } else {
        map.set(key, { value: c.value, count: c.count, variants: [c.value], _winnerCount: c.count });
      }
    });
    facetVariants[field] = {};
    var out = [];
    map.forEach(function(g) {
      facetVariants[field][g.value] = g.variants;
      out.push({ value: g.value, count: g.count });
    });
    return out;
  }

  /* Expande un valor de filtro a todas sus grafías conocidas */
  function expandFilterValues(field, values) {
    var known = facetVariants[field] || {};
    var out = [];
    values.forEach(function(v) {
      var variants = known[v];
      if (variants && variants.length) {
        variants.forEach(function(x) { if (out.indexOf(x) === -1) out.push(x); });
      } else if (out.indexOf(v) === -1) {
        out.push(v);
      }
    });
    return out;
  }

  function renderFacets(facetCounts, activeParams) {
    if (!facetCounts || !facetCounts.length) return;

    // Mostrar sidebar y activar layout de 2 columnas
    sidebarEl.hidden = false;
    searchLayout.classList.add('has-sidebar');

    var html = '';

    facetCounts.forEach(function(facet) {
      var field = facet.field_name;
      var label = FACET_LABELS[field] || field;
      var counts = facet.counts;

      /* Precio: slider doble (ThemeUtils.rangeSlider), no checkboxes.
         Límites de facet_stats — pero con filtro de precio activo las stats
         se encogen al rango filtrado, así que cacheamos los límites sin
         filtro por query para poder volver a ampliar. */
      if (field === 'price') {
        var stats = facet.stats;
        if (stats && stats.max > stats.min) {
          var bMin = Math.floor(stats.min);
          var bMax = Math.ceil(stats.max);
          var hasPriceFilter = activeParams.price_min !== '' || activeParams.price_max !== '';
          if (!hasPriceFilter) {
            priceBounds = { q: activeParams.q, min: bMin, max: bMax };
          } else if (priceBounds && priceBounds.q === activeParams.q) {
            bMin = priceBounds.min;
            bMax = priceBounds.max;
          }
          html += '<div class="facet-group" data-field="price">'
            + '<div class="facet-group__label">' + label
            + '<svg class="facet-group__toggle" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>'
            + '</div>'
            + '<div class="facet-group__options">'
            + '<div data-price-slider data-min="' + bMin + '" data-max="' + bMax + '"></div>'
            + '</div></div>';
        }
        return;
      }

      // Marca/categoría: unir grafías duplicadas (TAMA/Tama)
      if (field === 'vendor' || field === 'product_type') {
        counts = dedupeFacetCounts(field, counts).sort(function(a, b) { return b.count - a.count; });
      }

      var activeValues = activeParams[field] || (field === 'available' && activeParams.available ? [activeParams.available] : []);
      /* Con algo marcado se muestra el grupo completo: una opción activa que
         cae fuera de las 8 primeras quedaba escondida tras el "+N más", así
         que el cliente no veía qué tenía filtrado. Mismo criterio que en
         colección. */
      var hayActivos = Array.isArray(activeValues) ? activeValues.length > 0 : !!activeValues;
      var showMore = counts.length > 8 && !hayActivos;
      var visibleCounts = showMore ? counts.slice(0, 8) : counts;

      html += '<div class="facet-group" data-field="' + field + '">'
        + '<div class="facet-group__label">'
        + label
        + '<svg class="facet-group__toggle" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>'
        + '</div>'
        + '<div class="facet-group__options">';

      visibleCounts.forEach(function(opt) {
        var val = opt.value;
        var displayVal = field === 'available' ? (AVAILABLE_LABELS[val] || val) : val;
        var checked = Array.isArray(activeValues)
          ? activeValues.indexOf(val) !== -1
          : activeValues === val;

        html += '<label class="facet-option">'
          + '<input type="checkbox" data-field="' + field + '" value="' + escapeHtml(val) + '"' + (checked ? ' checked' : '') + '>'
          + '<span class="facet-option__label">' + escapeHtml(displayVal) + '</span>'
          + '<span class="facet-option__count">' + opt.count + '</span>'
          + '</label>';
      });

      html += '</div>';

      if (showMore) {
        html += '<button type="button" class="facet-group__show-more" data-total="' + counts.length + '">+'
          + (counts.length - 8) + ' más</button>';
      }

      html += '</div>';
    });

    facetsEl.innerHTML = html;

    // Slider de precio: init tras insertar el HTML
    var sliderEl = facetsEl.querySelector('[data-price-slider]');
    if (sliderEl && window.ThemeUtils && ThemeUtils.rangeSlider) {
      var sMin = parseInt(sliderEl.dataset.min, 10);
      var sMax = parseInt(sliderEl.dataset.max, 10);
      ThemeUtils.rangeSlider(sliderEl, {
        min: sMin,
        max: sMax,
        valueMin: activeParams.price_min !== '' ? activeParams.price_min : sMin,
        valueMax: activeParams.price_max !== '' ? activeParams.price_max : sMax,
        format: formatPriceLabel,
        parse: function(s) { var n = parseInt(String(s).replace(/[^\d]/g, ''), 10); return isNaN(n) ? null : n * 100; },
        labelMin: 'Precio mínimo',
        labelMax: 'Precio máximo',
        onCommit: function(lo, hi) {
          var params = getParams();
          params.price_min = lo > sMin ? String(lo) : '';
          params.price_max = hi < sMax ? String(hi) : '';
          params.page = 1;
          captureSearch('tms_search_filter_changed', params, {
            filter_field: 'price',
            filter_action: params.price_min || params.price_max ? 'applied' : 'removed',
            filter_value: [params.price_min, params.price_max].join(':')
          });
          navigate(params, true);
        }
      });
    }

    // Show-more por grupo
    facetsEl.querySelectorAll('.facet-group__show-more').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.facet-group');
        var field = group.dataset.field;
        var facet = facetCounts.find(function(f) { return f.field_name === field; });
        if (!facet) return;

        var opts = group.querySelector('.facet-group__options');
        var activeValues = activeParams[field] || [];

        opts.innerHTML = facet.counts.map(function(opt) {
          var checked = activeValues.indexOf(opt.value) !== -1;
          return '<label class="facet-option">'
            + '<input type="checkbox" data-field="' + field + '" value="' + escapeHtml(opt.value) + '"' + (checked ? ' checked' : '') + '>'
            + '<span class="facet-option__label">' + escapeHtml(opt.value) + '</span>'
            + '<span class="facet-option__count">' + opt.count + '</span>'
            + '</label>';
        }).join('');

        btn.remove();
      });
    });

    // (El colapsar/expandir grupo se maneja por delegación en el init — funciona
    //  también para las facetas nativas movidas al drawer cuando TS cae.)
  }

  function renderPagination(found, page) {
    var totalPages = Math.ceil(found / perPage);
    if (totalPages <= 1) {
      paginationEl.hidden = true;
      return;
    }

    var params = getParams();
    var html = '<ul class="pagination">';

    if (page > 1) {
      html += '<li><a href="' + buildUrl(params, page - 1) + '" class="pagination__link pagination__link--prev" aria-label="Anterior">'
        + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M10 3L5 8L10 13"/></svg>'
        + '</a></li>';
    }

    var start = Math.max(1, page - 2);
    var end = Math.min(totalPages, page + 2);

    if (start > 1) {
      html += '<li><a href="' + buildUrl(params, 1) + '" class="pagination__link">1</a></li>';
      if (start > 2) html += '<li><span class="pagination__link pagination__link--ellipsis">…</span></li>';
    }

    for (var i = start; i <= end; i++) {
      if (i === page) {
        html += '<li><span class="pagination__link pagination__link--current" aria-current="page">' + i + '</span></li>';
      } else {
        html += '<li><a href="' + buildUrl(params, i) + '" class="pagination__link">' + i + '</a></li>';
      }
    }

    if (end < totalPages) {
      if (end < totalPages - 1) html += '<li><span class="pagination__link pagination__link--ellipsis">…</span></li>';
      html += '<li><a href="' + buildUrl(params, totalPages) + '" class="pagination__link">' + totalPages + '</a></li>';
    }

    if (page < totalPages) {
      html += '<li><a href="' + buildUrl(params, page + 1) + '" class="pagination__link pagination__link--next" aria-label="Siguiente">'
        + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 3L11 8L6 13"/></svg>'
        + '</a></li>';
    }

    html += '</ul>';
    paginationEl.innerHTML = html;
    paginationEl.hidden = false;
  }

  function renderActiveFilters(params) {
    var chips = [];
    var filterFields = ['vendor', 'product_type'];

    filterFields.forEach(function(field) {
      var values = params[field] || [];
      values.forEach(function(val) {
        chips.push({ field: field, value: val, label: FACET_LABELS[field] + ': ' + val });
      });
    });

    if (params.price_min !== '' || params.price_max !== '') {
      var lo = params.price_min !== '' ? formatPriceLabel(parseInt(params.price_min, 10)) : '…';
      var hi = params.price_max !== '' ? formatPriceLabel(parseInt(params.price_max, 10)) : '…';
      chips.push({ field: 'price', value: '', label: 'Precio: ' + lo + ' – ' + hi });
    }

    if (params.available === 'true') {
      // "En existencia": mismo término que el filtro nativo de la colección.
      chips.push({ field: 'available', value: '', label: 'En existencia' });
    } else if (params.available === 'false') {
      chips.push({ field: 'available', value: '', label: 'Agotados' });
    }

    if (chips.length === 0) return '';

    return '<div class="active-filters">'
      + chips.map(function(chip) {
          return '<button type="button" class="active-filter-chip" data-field="' + chip.field + '" data-value="' + escapeHtml(chip.value) + '">'
            + escapeHtml(chip.label)
            + '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3L9 9M9 3L3 9"/></svg>'
            + '</button>';
        }).join('')
      + '</div>';
  }

  // ─── Navegación por URL ───────────────────────────────────────────────────────
  // Cuando el usuario cambia filtros o página, actualizamos la URL sin recargar.
  // Esto mantiene el historial del navegador y hace los filtros bookmarkeables.

  function buildUrl(params, page) {
    var p = new URLSearchParams();
    if (params.q) p.set('q', params.q);
    p.set('type', 'product');
    if (page && page > 1) p.set('page', page);
    if (params.sort && params.sort !== 'relevance') p.set('sort', params.sort);
    (params.vendor || []).forEach(function(v) { p.append('vendor', v); });
    (params.product_type || []).forEach(function(v) { p.append('product_type', v); });
    if (params.available) p.set('available', params.available);
    if (params.aprox) p.set('aprox', params.aprox);
    if (params.sinStock) p.set('sin_stock', 'true');
    if (params.price_min !== '') p.set('price_min', params.price_min);
    if (params.price_max !== '') p.set('price_max', params.price_max);
    return window.location.pathname + '?' + p.toString();
  }

  function navigate(newParams, pushState) {
    var url = buildUrl(newParams, newParams.page);
    if (pushState) {
      window.history.pushState(null, '', url);
    } else {
      window.history.replaceState(null, '', url);
    }
    runSearch();
  }

  // ─── Orquestación principal ───────────────────────────────────────────────────

  function showLoading() {
    loadingEl.hidden = false;
    hide(resultsEl);
    hide(emptyEl);
    hide(errorEl);
      paginationEl.hidden = true;
    activeFiltersEl.innerHTML = '';
  }

  function runSearch() {
    var params = getParams();

    var hasFilters = params.vendor.length || params.product_type.length || params.available || params.price_min !== '' || params.price_max !== '';
    if (!params.q && !hasFilters) {
      loadingEl.hidden = true;
      emptyMsgEl.textContent = 'Escribe algo para buscar.';
      show(emptyEl);
      countEl.textContent = '';
      sidebarEl.hidden = true;
      searchLayout.classList.remove('has-sidebar');
      return;
    }

    showLoading();

    var searchId = ++currentSearchId;
    doSearch(params)
      .then(function(data) {
        if (searchId !== currentSearchId) return; // llegó tarde, hay una búsqueda más nueva
        logEngine(true);
        loadingEl.hidden = true;

        // Sync etiqueta de orden
        syncSortLabel(params.sort || 'relevance');

        // Contador — el término ya está en el título (H1)
        countEl.textContent = data.found.toLocaleString('es-CO') + ' producto' + (data.found !== 1 ? 's' : '');
        lastResultCount = data.found;

        if (window.TMSAnalytics) {
          TMSAnalytics.capture('tms_search_performed', {
            search_surface: 'results_page',
            search_engine: 'typesense',
            query: params.q,
            result_count: data.found,
            page: params.page,
            sort: params.sort,
            vendors: params.vendor,
            product_types: params.product_type,
            availability: params.available,
            price_min: params.price_min,
            price_max: params.price_max
          });
        }

        if (data.found === 0) {
          captureSearch('tms_search_zero_results', params, {
            result_count: 0,
            automatic_stock_retry: false
          });
          mostrarVacio(params);
          renderFacets(data.facet_counts, params);
          return;
        }

        /* Aviso cuando se quitó el filtro automáticamente */
        var avisoPrevio = document.querySelector('.search-notice');
        if (avisoPrevio) avisoPrevio.remove();
        if (params.sinStock) {
          var aviso = document.createElement('p');
          aviso.className = 'search-notice';
          aviso.textContent = 'No hay unidades disponibles de "' + params.q + '". Te mostramos '
            + data.found.toLocaleString('es-CO') + (data.found === 1 ? ' producto agotado.' : ' productos agotados.');
          resultsEl.insertAdjacentElement('beforebegin', aviso);
        }

        // Chips de filtros activos (contenedor propio, fuera del grid de resultados)
        activeFiltersEl.innerHTML = renderActiveFilters(params);

        // Cards de resultados
        var displayHits = data.hits;
        var utils = intentUtils();
        if ((params.sort || 'relevance') === 'relevance' && utils && utils.alternateBySuggestedVendors) {
          displayHits = utils.alternateBySuggestedVendors(data.hits, data.metadata);
        }
        var cardsHtml = displayHits.map(function(hit) { return renderCard(hit.document); }).join('');
        resultsEl.innerHTML = cardsHtml;
        show(resultsEl);
        /* Re-sincroniza el estado ♥ de las cards recién insertadas (wishlist.js) */
        document.dispatchEvent(new CustomEvent('wishlist:change'));

        renderFacets(data.facet_counts, params);
        renderPagination(data.found, params.page);
      })
      .catch(function(err) {
        if (searchId !== currentSearchId) return;
        loadingEl.hidden = true;
        /* Marcar Typesense caído (con TTL): el predictive lo comparte; expira a 60s */
        markTsDown();
        logEngine(false, err);
        if (window.TMSAnalytics) {
          TMSAnalytics.capture('tms_search_error', {
            search_surface: 'results_page',
            search_engine: 'typesense',
            query: params.q,
            fallback_available: showNativeFallback(),
            error: err && err.message ? err.message : 'unknown'
          });
        }
        if (!showNativeFallback()) {
          // No hay resultados nativos (ej: búsqueda sin q) — mostrar error
          show(errorEl);
        }
      });
  }

  // ─── Event listeners ─────────────────────────────────────────────────────────

  // Filtros: cambio de checkbox → actualizar URL y buscar
  // Colapsar/expandir grupo de facetas (delegado: sirve para TS y nativas)
  facetsEl.addEventListener('click', function(e) {
    var label = e.target.closest('.facet-group__label');
    if (!label || !facetsEl.contains(label)) return;
    label.closest('.facet-group').classList.toggle('is-collapsed');
  });

  facetsEl.addEventListener('change', function(e) {
    var checkbox = e.target.closest('input[type="checkbox"]');
    if (!checkbox) return;

    var params = getParams();
    var field = checkbox.dataset.field;
    var value = checkbox.value;

    if (field === 'available') {
      params.available = checkbox.checked ? checkbox.value : '';
    } else {
      var arr = params[field] || [];
      if (checkbox.checked) {
        if (arr.indexOf(value) === -1) arr.push(value);
      } else {
        arr = arr.filter(function(v) { return v !== value; });
      }
      params[field] = arr;
    }

    params.page = 1;
    captureSearch('tms_search_filter_changed', params, {
      filter_field: field,
      filter_action: checkbox.checked ? 'applied' : 'removed',
      filter_value: value
    });
    navigate(params, true);
  });

  // Chips de filtros activos → quitar filtro
  activeFiltersEl.addEventListener('click', function(e) {
    var chip = e.target.closest('.active-filter-chip');
    if (!chip) return;

    var params = getParams();
    var field = chip.dataset.field;
    var value = chip.dataset.value;

    if (field === 'available') {
      params.available = '';
    } else if (field === 'price') {
      params.price_min = '';
      params.price_max = '';
    } else {
      params[field] = (params[field] || []).filter(function(v) { return v !== value; });
    }

    params.page = 1;
    captureSearch('tms_search_filter_changed', params, {
      filter_field: field,
      filter_action: 'removed',
      filter_value: value
    });
    navigate(params, true);
  });

  // Limpiar todos los filtros
  document.getElementById('filters-clear-all').addEventListener('click', function() {
    var params = getParams();
    captureSearch('tms_search_filters_cleared', params, {
      cleared_vendors: params.vendor,
      cleared_product_types: params.product_type,
      cleared_availability: params.available,
      cleared_price_min: params.price_min,
      cleared_price_max: params.price_max
    });
    params.vendor = [];
    params.product_type = [];
    params.available = '';
    params.price_min = '';
    params.price_max = '';
    params.page = 1;
    navigate(params, true);
  });

  // Ordenamiento — dropdown custom (Ordenar)
  var sortToggle = document.getElementById('sort-toggle');
  var sortMenu   = document.getElementById('sort-menu');
  var sortLabel  = document.getElementById('sort-label');
  var sortWrap   = document.getElementById('search-sort-wrap');
  var SORT_LABELS = {
    relevance: 'Relevancia',
    price_asc: 'Precio: menor a mayor',
    price_desc: 'Precio: mayor a menor',
    newest: 'Más nuevos'
  };

  function syncSortLabel(sort) {
    if (sortLabel) sortLabel.textContent = SORT_LABELS[sort] || 'Ordenar';
    if (sortMenu) {
      sortMenu.querySelectorAll('[data-sort]').forEach(function(opt) {
        opt.setAttribute('aria-selected', opt.getAttribute('data-sort') === sort ? 'true' : 'false');
      });
    }
  }

  function closeSortMenu() {
    if (sortMenu) sortMenu.hidden = true;
    if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
  }

  if (sortToggle) {
    sortToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = sortMenu.hidden;
      sortMenu.hidden = !open;
      sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    sortMenu.addEventListener('click', function(e) {
      var opt = e.target.closest('[data-sort]');
      if (!opt) return;
      var params = getParams();
      params.sort = opt.getAttribute('data-sort');
      params.page = 1;
      captureSearch('tms_search_sort_changed', params, {
        selected_sort: params.sort
      });
      syncSortLabel(params.sort);
      closeSortMenu();
      navigate(params, true);
    });
    // Cerrar al hacer click fuera
    document.addEventListener('click', function(e) {
      if (sortWrap && !sortWrap.contains(e.target)) closeSortMenu();
    });
  }

  syncSortLabel(getParams().sort || 'relevance');

  // Retry en error
  document.getElementById('search-retry').addEventListener('click', runSearch);

  if (analyticsRoot) {
    analyticsRoot.addEventListener('click', function(e) {
      var productLink = e.target.closest('[data-analytics-product] a[href*="/products/"], a[data-analytics-product-link]');
      if (productLink) {
        var card = productLink.closest('[data-analytics-product]');
        var cards = Array.prototype.slice.call(analyticsRoot.querySelectorAll('[data-analytics-product]'));
        captureSearch('tms_search_result_clicked', getParams(), {
          search_engine: resultsEl && resultsEl.contains(productLink) ? 'typesense' : 'shopify_native',
          product_id: card && card.dataset.productId,
          product_handle: card && card.dataset.productHandle,
          product_title: card && card.dataset.productTitle,
          product_vendor: card && card.dataset.productVendor,
          product_type: card && card.dataset.productType,
          result_position: card ? cards.indexOf(card) + 1 : null,
          destination: productLink.pathname
        });
        return;
      }

      var paginationLink = e.target.closest('#search-pagination a[href]');
      if (paginationLink) {
        var destination = new URL(paginationLink.href, window.location.origin);
        captureSearch('tms_search_page_changed', getParams(), {
          destination_page: parseInt(destination.searchParams.get('page') || '1', 10)
        });
      }
    });
  }

  // Sidebar mobile
  var filtersToggle = document.getElementById('filters-toggle');
  var filtersClose  = document.getElementById('filters-close');
  var filtersApply  = document.getElementById('filters-apply');

  function openSidebar() {
    sidebarEl.classList.add('is-open');
    backdropEl.classList.add('is-open');
    backdropEl.hidden = false;
    sidebarEl.setAttribute('aria-hidden', 'false');
    filtersToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    sidebarEl.classList.remove('is-open');
    backdropEl.classList.remove('is-open');
    sidebarEl.setAttribute('aria-hidden', 'true');
    filtersToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function() { backdropEl.hidden = true; }, 300);
  }

  filtersToggle.addEventListener('click', openSidebar);
  filtersClose.addEventListener('click', closeSidebar);
  filtersApply.addEventListener('click', closeSidebar);
  backdropEl.addEventListener('click', closeSidebar);

  // Navegación con botón atrás/adelante del navegador
  window.addEventListener('popstate', runSearch);

  // ─── Init ─────────────────────────────────────────────────────────────────────

  /* Por defecto: solo "en existencia" (igual que la colección). Si la URL no
     trae ningún filtro y hay término de búsqueda, preseleccionamos available=true
     una sola vez (replaceState → no ensucia el historial). El cliente puede
     destildar "Disponible" en la sidebar para ver los agotados. */
  function applyDefaultInStock() {
    if (!config.defaultInStock || tsDown) return false;
    var p = new URLSearchParams(window.location.search);
    var hasFilter = p.has('available') || p.has('vendor') || p.has('product_type') || p.has('price_min') || p.has('price_max');
    var params = getParams();
    if (hasFilter || !params.q) return false;
    params.available = 'true';
    navigate(params, false); // replaceState + runSearch
    return true;
  }

  // Si TS ya estaba caído, el fallback nativo ya se mostró; no reintentamos.
  if (!tsDown && !applyDefaultInStock()) runSearch();

})();
